/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} StatusInputs */

const th_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถานะ`)
};

const en_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const ja_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状況`)
};

const zh_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态`)
};

const es_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const pt_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situação`)
};

const id_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const fr_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

const tl_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katayuan`)
};

const vi_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạng thái`)
};

const ko_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상태`)
};

const de_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const ru_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const tr_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durum`)
};

const it_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato`)
};

const pl_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const uk_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const hi_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति`)
};

const ar_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحالة`)
};

const ms_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const bn_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অবস্থা`)
};

const zh_tw2_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`狀態`)
};

const zh_hk2_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`狀態`)
};

const ur_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حالت`)
};

const fa_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وضعیت`)
};

const sw_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hali`)
};

const nl_status = /** @type {(inputs: StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {StatusInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const status = /** @type {((inputs?: StatusInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<StatusInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_status(inputs)
	if (locale === "ja") return ja_status(inputs)
	if (locale === "zh") return zh_status(inputs)
	if (locale === "es") return es_status(inputs)
	if (locale === "pt") return pt_status(inputs)
	if (locale === "id") return id_status(inputs)
	if (locale === "fr") return fr_status(inputs)
	if (locale === "tl") return tl_status(inputs)
	if (locale === "vi") return vi_status(inputs)
	if (locale === "ko") return ko_status(inputs)
	if (locale === "de") return de_status(inputs)
	if (locale === "ru") return ru_status(inputs)
	if (locale === "tr") return tr_status(inputs)
	if (locale === "it") return it_status(inputs)
	if (locale === "pl") return pl_status(inputs)
	if (locale === "uk") return uk_status(inputs)
	if (locale === "hi") return hi_status(inputs)
	if (locale === "ar") return ar_status(inputs)
	if (locale === "ms") return ms_status(inputs)
	if (locale === "bn") return bn_status(inputs)
	if (locale === "zh-TW") return zh_tw2_status(inputs)
	if (locale === "zh-HK") return zh_hk2_status(inputs)
	if (locale === "ur") return ur_status(inputs)
	if (locale === "fa") return fa_status(inputs)
	if (locale === "sw") return sw_status(inputs)
	if (locale === "nl") return nl_status(inputs)
	return en_status(inputs)
});